import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import useStyles from "./style";

function Circle({ size }) {
  const classes = useStyles();
  return (
    <div className={classes.cirle}>
      <CircularProgress size={size} />
    </div>
  );
}

export default Circle;
